/* 0.46.39 - Whether white text reads better than the platform's
 * near-black on a stored color: a Henaket token ('--color-blue-800',
 * read from the page's own CSS) or a custom '#RRGGBB'. WCAG relative
 * luminance and contrast, the same test the Layer element uses.
 * Unknown or empty values give false (dark text). */
import { colorCss } from './colorCss';

function resolveHex(value) {
  const css = colorCss(value);
  if (!css) return null;
  if (css.startsWith('#')) return css;
  if (typeof window === 'undefined' || !window.getComputedStyle) return null;
  const v = getComputedStyle(document.documentElement)
    .getPropertyValue(String(value).trim()).trim();
  return /^#[0-9A-Fa-f]{3}([0-9A-Fa-f]{3})?$/.test(v) ? v : null;
}

export function isDarkColor(value) {
  let h = (resolveHex(value) || '').replace('#', '');
  if (h.length === 3) h = h.split('').map(c => c + c).join('');
  if (!/^[0-9a-fA-F]{6}$/.test(h)) return false;
  const lin = (i) => {
    const c = parseInt(h.slice(i, i + 2), 16) / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  };
  const L = 0.2126 * lin(0) + 0.7152 * lin(2) + 0.0722 * lin(4);
  return (1.05 / (L + 0.05)) > ((L + 0.05) / 0.0603);
}

/* Inline style for a chip painted in a stored color, or undefined.
 * 0.46.43 - `stroke`: an optional outline color, drawn 1px INSIDE the
 * chip (an inset shadow), so the chip keeps its size with or without it. */
export function chipStyle(value, stroke, text) {
  const bg = colorCss(value);
  const line = colorCss(stroke);
  // 0.48.05 - The text color chosen for the chip, over the automatic one.
  const ink = colorCss(text);
  if (!bg && !line && !ink) return undefined;
  const out = {};
  if (bg) {
    out.background = bg;
    out.color = isDarkColor(value) ? 'var(--color-white, #fff)' : 'var(--color-text-800)';
  }
  if (ink) out.color = ink;
  if (line) out.boxShadow = `inset 0 0 0 1px ${line}`;
  return out;
}
